import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs/operators";

@Component({
  selector: 'bdr-info-master-configuration',
  templateUrl: './bdr-info-master-configuration.component.html',
  styleUrls: ['./bdr-info-master-configuration.component.scss']
})
export class BdrInfoMasterConfigurationComponent implements OnInit {
  @Input() infoMasterConfiguration: any;
  segmentPath: string;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.url.pipe(
      map(url => {
        const path = url[0] ? url[0].path : 'home';
        return path;
      })
    )
      .subscribe(path => {
        this.segmentPath = path;
      });
  }

}
